// enodePlugin.js

import enodeLib from 'enode-lib'
import config from '@/config/config.app.json'
import Vue from 'vue'

let instance = null;
let pollingTimer = null;

export function createEnodeLib() {
    if (!instance) {
        console.log('Starting Enode Lib...');
        let rhRequest = Vue.prototype.$rhRequest
        instance = new enodeLib(rhRequest, config)
    }
    return instance;
}

export function startEnodePolling() {
    if (pollingTimer || !instance || !Object.hasOwn(config, 'enodeRedirect')) return;

    if (Vue.prototype.$rhAuth.loggedIn()) {
        instance.getData()
    }

    pollingTimer = setInterval(() => {
        if (Vue.prototype.$rhAuth.loggedIn()) {
            instance.getData()
        }
    }, 10000)
}

export function stopEnodePolling() {
    if (pollingTimer) {
        clearInterval(pollingTimer)
        pollingTimer = null
    }
}